<lib-custom-modal [title]="ModifyColumnDisplayTitle"
  [modalSize]="'large'"
  (close)="hideModal('modalClose')"
  #modifyColumnDisplayModal>
  <ng-container class="app-modal-body">
    <div class="border-top"></div>
    <div class="row">
      <div class="col-md-12 mt-1 pe-4">
        <label class="fw-bold pt-2">{{ModifyColumnDisplaySubTitle}}</label>
      </div>
    </div>
    <div class="border-top"></div>
    <lib-messaging [message]="printDuplicateColError"
      [field]="modifyColumnDisplayModalMsgFieldConfig"
      [messageStyle]="'form-message'"
      *ngIf="!ModifyColumnDisplayForm.valid"
      id="modify-column-display-modal-error-message" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-messaging>
    <div class="row">
      <div class="col-md-4 mt-3">
        <h5>Column 1</h5>
      </div>
      <div class="col-md-8 mt-1 pe-4">
        <label class="fw-bold pt-2">{{ModifyClaimNumberSubTitle}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mt-3">
        <h5>Column 2</h5>
      </div>
      <div class="col-md-8 mt-1 pe-4">
        <lib-select #columnTwoSelection
          [field]="columnTwoSelection"
          [group]="ModifyColumnDisplayForm" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mt-3">
        <h5>Column 3</h5>
      </div>
      <div class="col-md-8 pe-4">
        <lib-select #columnThreeSelection
          [field]="columnThreeSelection"
          [group]="ModifyColumnDisplayForm" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mt-3">
        <h5>Column 4</h5>
      </div>
      <div class="col-md-8 pe-4">
        <lib-select #columnFourSelection
          [field]="columnFourSelection"
          [group]="ModifyColumnDisplayForm" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mt-3">
        <h5>Column 5</h5>
      </div>
      <div class="col-md-8 pe-4">
        <lib-select #columnFiveSelection
          [field]="columnFiveSelection"
          [group]="ModifyColumnDisplayForm" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mt-3">
        <h5>Column 6</h5>
      </div>
      <div class="col-md-8 pe-4">
        <lib-select #columnSixSelection
          [field]="columnSixSelection"
          [group]="ModifyColumnDisplayForm" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-select>
      </div>
    </div>
    <div *ngIf="context !== 'osha' " class="row">
      <div class="col-md-4 mt-3">
        <h5>Column 7</h5>
      </div>
      <div class="col-md-8 pe-4">
        <lib-select #columnSevenSelection
          [field]="columnSevenSelection"
          [group]="ModifyColumnDisplayForm" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-select>
      </div>

    </div>
    <div class="border-bottom"></div>
  </ng-container>
  <ng-container class="app-modal-footer">
    <div class="row">

      <div class="col-md-4"
        style="text-align: left;">
        <lib-button #cancelBtnTemplate
          (click)="hideModal('modalCancel')" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-button>
      </div>
      <div class="col-md-4">
      </div>
      <div class="col-md-4">
        <lib-button #saveSelectioneBtnTemplate
          (click)="SaveSelectionBtn()" [attr.data-dl]="JSON.stringify({da_track: 'true'})"></lib-button>
      </div>
    </div>
  </ng-container>
</lib-custom-modal>